import React, { useEffect, useState } from 'react';
import { ulid } from 'ulid';
import { Link } from 'react-router-dom';
import Spinner from '../../components/spinner/spinner';
import endpointConfig from '../../config/endpointConfig';
import notifyHB from '../../config/notifyHB';

interface RegisterProps {
	// nextStep: Function
	// personName: string
	// personLastName: string
	// address: string
	// userPhoneCountryCode: string
	// userPhone: string
	// nit: string
	// profession: string
	// userEmail: string
	// documentNumber: number
	// onboardingLS: Function
}

const DiditCallback: React.FC<RegisterProps> = (
	{
		// nextStep,
		// personName,
		// personLastName,
		// address,
		// userPhoneCountryCode,
		// userPhone,
		// nit,
		// profession,
		// userEmail,
		// documentNumber,
		// onboardingLS
	},
) => {
	const [user, setUser] = useState('');
	const [authToken, setAuthToken] = useState('');

	useEffect(() => {
		const getToken = async () => {
			setTimeout(function () {
				setAuthToken(
					JSON.parse(localStorage.getItem('user-info') || '{}'),
				);
				setUser(JSON.parse(localStorage.getItem('login-data') || '{}'));
			}, 1000);
		};
		getToken().catch(console.debug);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div>
			<h3>Gracias por validar tu identidad!</h3>
			<div className="cyber-spacer small"></div>
			<h4>Puedes continuar el proceso en tu computadora.</h4>
		</div>
	);
};

export default DiditCallback;
